import queryString from "query-string";

const getUrlParam = (location: { search: string }, param: string) => {
  const params = queryString.parse(location.search);
  return params[param];
};

export default getUrlParam;
